import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TextInput,
  Button,
  FormGroup,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DropdownSkeleton,
  Toggle
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { ComboBox } from '../../helpers/ComboBox';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { FindGHRSEmployer } from '../common/FindGHRSEmployer';
import { entitiesLabels } from '../../helpers/Constants';

export class WitnessPeopleModal extends Component {
  incidentWitnessPeopleModel = (props) => {
    if (props.isEditModal) {
      return { ...props.editModel };
    }

    return {
      id: null, //guid
      idIncident: null, //guid
      witnessStatement: false, //bool
      idInvolvedPerson: null, //guid = involvedPerson.id
      involvedPerson: {
        id: null, //guid
        type: '',
        badgeNumber: '',
        nationalID: '',
        fullname: '',
        //nationality: '',
        idEmployer: null, //guid
      },
    };
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
    this.state = {
      model: {
        ...this.incidentWitnessPeopleModel(props),
      },
      mode: props.mode || 0,
    };
  }

  handleChangeModel = (el) => {
    let inputName = el.target.name;
    let inputValue = el.target.value;

    let statusCopy = Object.assign({}, this.state.model);
    statusCopy.involvedPerson[inputName] = inputValue;

    this.setState({ model: statusCopy });
  };

  handleChangeComboType = (inputName, selectedItem, objName) => {
    let inputValue = selectedItem ? selectedItem.id : null;
    let statusCopy = Object.assign({}, this.state);

    statusCopy.model.involvedPerson[inputName] = inputValue;

    this.setState(statusCopy);
  };

  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };

  handleToggle = (value, id) => {
    let statusCopy = Object.assign({}, this.state.model);
    statusCopy.witnessStatement = value;

    this.setState({ model: statusCopy });
  };

  setEmployer = (employer) => {
    if (employer && employer.id) {
      let statusCopy = Object.assign({}, this.state.model);
      statusCopy.involvedPerson.idEmployer = employer.id;
      statusCopy.involvedPerson.badgeNumber = employer.ghrS_ID;
      statusCopy.involvedPerson.nationalID = employer.national_ID;
      statusCopy.involvedPerson.fullname = employer.fullname;

      this.setState({ model: statusCopy, mode: 2 });
    }
  };

  save = () => {
    if (this.validator.allValid()) {
      this.props.save(this.state.model);
      showNotification.success(`${entitiesLabels.SUCCESS}`, 'Witness People created successfully');
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        entitiesLabels.WITNESSPEOPLE + ' required fields are missing  '
      );
      this.forceUpdate();
    }
  };

  render() {
    const validations = {
      // immediateActions: this.validator.message('immediateActions', this.state.hocCardModel.immediateActions, 'required'),
      type: this.validator.message('type', this.state.model.involvedPerson.type, 'required'),
      fullname: this.validator.message(
        'fullname',
        this.state.model.involvedPerson.fullname,
        'required'
      ),
      // nationalID: this.validator.message('nationalID', this.state.model.involvedPerson.nationalID, 'required'),
    };
    const modalHeader = {
      title: this.props.isEditModal ? 'Edit ' : 'Add new ',
      iconDescription: 'Close',
      buttonOnClick: () => this.props.toggleModal(false),
    };
    const { title, isOpenModal } = this.props;

    //RITM1197573
    const appType = (this.props.appType || []).filter(
      (el) => (el.inUse) || this.state.model?.involvedPerson.type == el.id);

    const selectedItemCombo = {
      type: (appType || []).find((el) => el.id == this.state.model.involvedPerson.type), //RITM1197573
    };

    return this.state.mode == 1 ? (
      <FindGHRSEmployer
        isOpenModal={isOpenModal}
        onCancel={() => this.props.toggleModal(false)}
        onOk={this.setEmployer}
      />
    ) : (
      <ComposedModal
        className="light-modal"
        open={isOpenModal}
        danger="false"
        onClose={() => {
          return false;
        }}
      >
        <ModalHeader className="margin-modal" {...modalHeader}>
          <p>{title || ''}</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          {this.state.mode == 0 ? (
            <div className="bx--row two-button-center modal--elemnts-buttons">
              <Button
                kind="primary"
                className="bx--col-md-6"
                onClick={() => this.handleChangeMode(1)}
              >
                GHRS research
              </Button>
              <Button
                kind="primary"
                className="bx--col-md-6"
                onClick={() => this.handleChangeMode(2)}
              >
                Manual input
              </Button>
            </div>
          ) : (
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <div className="bx--col-lg-6 bx--col-md-6">
                  <FormGroup legendText="Type*">
                    {appType == null ? ( //RITM1197573
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="type"
                        placeholder="Select"
                        name="type"
                        alt="involvedPerson"
                        onChange={this.handleChangeComboType}
                        itemToString={(item) => (item ? item.name : '')}
                        initialSelectedItem={selectedItemCombo.type}
                        items={appType} //RITM1197573
                        invalid={validations.type != null}
                      />
                    )}
                    {validations.type}
                  </FormGroup>
                </div>
                <div className="bx--col-lg-6 bx--col-md-6">
                  <FormGroup legendText="Witness Statement">
                    <Toggle
                      id="witnessStatement"
                      aria-label=""
                      labelText=""
                      labelA="No"
                      labelB="Yes"
                      toggled={this.state.model.witnessStatement || false}
                      onToggle={this.handleToggle}
                    />
                  </FormGroup>
                </div>
                <div className="bx--col-lg-6 bx--col-md-6">
                  <FormGroup legendText="Full name*">
                    <TextInput
                      id="txt-fullname"
                      name="fullname"
                      placeholder="Input full name"
                      value={this.state.model.involvedPerson.fullname}
                      onChange={this.handleChangeModel}
                      type="text"
                      hideLabel={true}
                      labelText=""
                      disabled={this.state.model.involvedPerson.idEmployer != null}
                      invalid={validations.fullname != null}
                    />

                    {validations.fullname}
                  </FormGroup>
                </div>
                {/* Removed in RITM0701238 */}
                {/* <div className="bx--col-lg-6 bx--col-md-6">
                  <FormGroup legendText="National ID (CF)">
                    <TextInput
                      id="nationalID"
                      name="nationalID"
                      placeholder="Input national ID"
                      value={
                        this.state.model.involvedPerson.nationalID != null
                          ? this.state.model.involvedPerson.nationalID
                          : ''
                      }
                      onChange={this.handleChangeModel}
                      type="text"
                      hideLabel={true}
                      labelText=""
                      disabled={this.state.model.involvedPerson.idEmployer != null}
                      invalid={validations.nationalID != null}
                    /> */}

                    {/* {validations.nationalID} */}
                  {/* </FormGroup>
                </div> */}
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.save()}>
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}

WitnessPeopleModal.propTypes = {
  save: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isEditModal: PropTypes.bool,
  isOpenModal: PropTypes.bool,
  mode: PropTypes.number,
  title: PropTypes.string,
  appType: PropTypes.array,
};
